// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from '@/pages/home/home.vue'
import router from '@/router/home-index'
import request from '@/util/request'
import API from '@/util/api'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'

import EnLanguage from '@/language/en'
import ChLanguage from '@/language/zh_CN'

// 通过插件的形式挂载
Vue.use(VueI18n)

// 英文官网，进来就把语言设置成英文
if(location.pathname === '/en' || location.pathname === '/en/download') {
  Cookies.set('django_language', 'en')
} else {
  if(!(location.pathname === '/en/set-meal' && Cookies.get('django_language') == 'en')){
    Cookies.set('django_language', 'zh-cn')
  }
}

const cookieLang = Cookies.get('django_language') || 'en';
const lng = cookieLang === 'zh-cn' ? 'zh_CN' : 'en';

const i18n = new VueI18n({
  // 语言标识
  locale: lng,
  messages: {
    'zh_CN': ChLanguage,
    'en': EnLanguage
  }
})

window.i18n = i18n;

// 子组件不需要引用直接使用
window.request = request;
window.API = API;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  lang: lng,
  i18n,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})
